module.exports = __webpack_public_path__ + "img/arrow-icon.948e5202.svg";